<template>
  <div>
    <div class="container pt-0">
      <div class="row">
        <div v-if="isClinius" class="col" :class="{ 'text-center': isClinius }">
          <h1 :class="{ 'fs-40': isClinius }">{{ $t("heading_booking") }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="pane">
            <div class="row">
              <div class="col-md-5 pr-lg-5 text-left" :class="{'border-right': !isMobile}">
                <h2>{{ $t("desired_appointment") }}</h2>
                <termin-zusammenfassung/>
              </div>
              <div class="col-md-7">
                <div class="text-center">
                  <div class="mt-3 text-confirm-head" :class="{'text-primary' : isClinius}">
                    Termin vereinbart
                  </div>
                  <div class="row mt-5 text-confirm">
                    <div class="col-md-8 offset-md-2">
                      Der Termin wurde vereinbart, eine Bestätigungsmail wurde an die angegebene Email-Adresse versandt.
                    </div>
                    <div class="col-md-8 offset-md-2 mt-15">
                      <a :href="restartLink">Neuen Termin vereinbaren.</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import Start from "@/components/Start.vue";

import TerminZusammenfassung from "@/components/TerminZusammenfassung";

export default {
  name: "CallcenterTerminbestaetigung",
  components: {
    TerminZusammenfassung
  },
  computed: {
    proposal() {
      return this.$store.state.termin.selectedTermin;
    },
    restartLink() {
      return "?callcenter="+this.$route.query.callcenter
    }
  },
};
</script>
